import classes from './security-msg.module.scss';
import lock from './../../../../assets/icons/lock.svg';

declare function Translate(key: string): string;

const SecurityMessage = () => {
  return (
    <div className={classes.security_message_container}>
      <div className={classes.security_notice}>
        <img src={lock} alt="" aria-hidden="true"/>
        <span>{Translate("N_General_Security")}</span>
      </div>
      <div className={classes.rights}>
        {Translate('N_General_all_right_reserved')}
      </div>
    </div>
  );
};

export default SecurityMessage;
